// extracted by mini-css-extract-plugin
export default {"bowls-page":"bowls_bowls-page__4NM4L"};